import React, { Component } from 'react'
import NoValue from '@modules/form/components/NoValue'
import { FieldGroup } from '@modules/form/form.module'
import {
	FastField,
	connect as formikConnect,
	FieldArray
} from 'formik'

const getNewContact = () => ({
	name: '',
	role: '',
	telephone: '',
	email: '',
})

export default
class Contacts extends Component {
	render() {
		const { isEditing, name, formik } = this.props;
		const values = formik.values[name];

		if(!isEditing && !(values && values.length)) {
			return <NoValue />
		}

		return (
			<FieldArray name={name} render={({ push, remove }) => {
				return (
					<div className="Contacts">
					{ values.map((v, i) => (
						<div className="Contact FieldLine" key={i}>
							<div className="FieldLine-header">
								<h3>Contact {i+1}</h3>
								{ isEditing &&
									<button type="button" className="btn btn-primary" onClick={() => remove(i)}>Remove</button>
								}
							</div>
							<FieldGroup type="text" name={`${name}.${i}.name`} label="Contact Name" isEditing={isEditing} />
							<FieldGroup type="text" name={`${name}.${i}.role`} label="Contact Role" isEditing={isEditing} />
							<FieldGroup type="text" name={`${name}.${i}.telephone`} label="Phone Number" isEditing={isEditing} />
							<FieldGroup type="text" name={`${name}.${i}.email`} label="Email" isEditing={isEditing} />
						</div>
					))}
					{
						isEditing
						&& <button type="button" className="btn btn-primary" onClick={() => push(getNewContact())}>Add contact</button>
					}
					</div>
				)
			}} />
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/form/components/input/Contacts.jsx